import { render, staticRenderFns } from "./bussinessTypeMinor.vue?vue&type=template&id=b0cc1304&scoped=true"
import script from "./bussinessTypeMinor.vue?vue&type=script&lang=js"
export * from "./bussinessTypeMinor.vue?vue&type=script&lang=js"
import style0 from "./bussinessTypeMinor.vue?vue&type=style&index=0&id=b0cc1304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cc1304",
  null
  
)

export default component.exports